var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLayout = function SvgLayout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "#212121",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.5C4.17157 3.5 3.5 4.17157 3.5 5V8.5H20.5V5C20.5 4.17157 19.8284 3.5 19 3.5H5ZM21.5 5C21.5 3.61929 20.3807 2.5 19 2.5H5C3.61929 2.5 2.5 3.61929 2.5 5V19C2.5 20.3807 3.61929 21.5 5 21.5H19C20.3807 21.5 21.5 20.3807 21.5 19V5ZM20.5 9.5H9.5V20.5H19C19.8284 20.5 20.5 19.8284 20.5 19V9.5ZM8.5 20.5V9.5H3.5V19C3.5 19.8284 4.17157 20.5 5 20.5H8.5Z"
  })));
};
export default SvgLayout;